// For some strange reason, the slider on the '.home-content-slider' section
// outputs more pager links than there are images. This snippet removes the
// empty pagers.
(function ($) {
    $(function () {
        // Wait for the slider to initialise.
        setTimeout(function () {
            var section = $('.home-content-slider');

            if (section.length === 0) {
                return;
            }

            var pagers = section.find('.pager a');

            if (pagers.length === 0) {
                return;
            }

            pagers.each(function () {
                var pager = $(this);
                var pagerText = pager.text();

                // Remove empty pagers
                if (pagerText === '') {
                    pager.remove();
                }
            });
        }, 25);
    });
})(jQuery);